import React from 'react'

import image1 from '../../assets/img1.jpg';
import image2 from '../../assets/img2.jpg';
import image3 from '../../assets/img3.jpg';



const CarouselComponent = () => {
    return (
        <>
         
        </>
    )
}

export default CarouselComponent
